import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { WithdrawalStatus } from "../../interfaces/withdrawal";

interface WithdrawalStatusLabelProps {
    value?: WithdrawalStatus;
}

export function WithdrawalStatusLabel({ value }: WithdrawalStatusLabelProps) {
    const { palette } = useTheme();

    const statusMap: Record<
        WithdrawalStatus | "default",
        { label: string; color: string }
    > = {
        approved: { label: "Aprovado", color: palette.success.main },
        rejected: { label: "Recusado", color: palette.error.main },
        pending: { label: "Pendente", color: palette.warning.main },
        failed: { label: "Falhou", color: palette.error.main },
        default: { label: "Não definido", color: palette.text.disabled },
    };

    const { label, color } = value ? statusMap[value] : statusMap.default;

    return (
        <Chip
            label={label}
            size="small"
            sx={{
                borderRadius: 1,
                color,
                backgroundColor: `${color}18`,
                border: `1px solid ${color}40`,
                fontWeight: 500,
            }}
        />
    );
}
